/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from '@ui-propulsion/react-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Link from 'next/link';
import styles from './logoAddress.module.scss';
import trackHeapEvent from '../../../services/helpers/trackHeapEvent';
import SmartImage from '../../smartImage/smartImage';

export default function LogoAddress({
  logo = {
    path: '',
    alt: '',
    link: '/',
  },
  address = '',
  cta = null,
}) {
  const checkYourRateClick = () => {
    trackHeapEvent(
      {
        Name: cta.heapKey ? cta.heapKey : 'Global Footer Trusted Badge',
        CTA: 'Check Your Rate',
      },
      'CMS_Unification'
    );
  };

  return (
    <div className={styles.logoAddress}>
      {logo?.path && (
        <Link href={logo?.link}>
          <SmartImage
            className={styles.logo}
            loading="lazy"
            alt={logo?.alt}
            src={logo.path}
            height={logo.height}
            width={logo.width}
          />
        </Link>
      )}
      <div className={styles.address}>{parse(`${address}`)}</div>
      {cta && cta?.link && (
        <div className={styles.cta}>
          <Button
            color="red"
            fullWidth
            href={cta?.link}
            onClick={checkYourRateClick}
          >
            {cta?.label}
          </Button>
        </div>
      )}
    </div>
  );
}

LogoAddress.propTypes = {
  logo: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  address: PropTypes.string,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    heapKey: PropTypes.any,
  }),
};
